import React from 'react';
import { STAFF_ROLE_OPTIONS } from '../lib/staff';

/** Role dropdown for Staff Directory add/edit forms. */
export default function StaffRoleSelect({ value, onChange, className = '' }) {
  return (
    <select className={className} value={value} onChange={onChange}>
      {STAFF_ROLE_OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
